import React from 'react';
import IndexComponent from './Index.component';

const IndexContainer = () => {
    return <IndexComponent    />;
};

export default IndexContainer;    